// extracted by mini-css-extract-plugin
module.exports = {"barcodeImage":"barcode_barcodeImage__VZlRq","barcodeDisplayValue":"barcode_barcodeDisplayValue__ux7Ar"};